// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/adc-ahrs-and-failure.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/adc-ahrs-and-failure/adc-ahrs-and-failure.js';

mount([g0]);
